/**
 * @module components/RequestSummary
 * @author Charles Blais <charles.blais@canada.ca>
 * 
 * Request summary table
 */

import { Row, Col, Table } from 'react-bootstrap';

import { useLanguageState } from '../contexts/language-state-provider';


type Props = {
  variables: HazardParameters
}


/**
 * React component
 * ===============
 */
const RequestSummary = ({
  variables,
}: Props) => {
  const [ lang ] = useLanguageState();


  let tr = (
    <tr>
      <th>Model</th>
      <td>{lang.modelMap[variables.code]}</td>
    </tr>
  )

  // There are two types of displays depending if the requested
  // is "nbc" or "canSHM".
  if ( /^nbc/i.test(variables.code) ) {
    tr = (
      <tr>
        <th>{lang.form.code}</th>
        <td>{lang.codeMap[variables.code]}</td>
      </tr>
    )
  }

  return (
    <Row>
      <Col sm={4}>
        <Table bordered condensed responsive>
          <caption>{lang.summary.details}</caption>
          <tbody>
            { tr }
            { ('siteClass' in variables && variables.siteClass) &&
              <tr>
                <th>{lang.summary.siteDesignationXS}</th>
                <td>X<sub>{variables.siteClass}</sub></td>
              </tr>
            }
            { ('vs30' in variables && variables.vs30)  && (
              <tr>
                <th>{lang.summary.siteDesignationXV}</th>
                <td>X<sub>{variables.vs30}</sub></td>
              </tr>
            )}
            <tr>
              <th>Latitude (&deg;)</th>
              <td>{Math.round(variables.latitude * 1000)/1000}</td>
            </tr>
            <tr>
              <th>Longitude (&deg;)</th>
              <td>{Math.round(variables.longitude * 1000)/1000}</td>
            </tr>
          </tbody>  
        </Table>
      </Col>
    </Row>
  );
};

export default RequestSummary;